import type { AuthUser } from "@/lib/api";

export function getDefaultRouteForUser(user: Pick<AuthUser, "role" | "can_evaluate">): string {
  switch (user.role) {
    case "estudiante":
      return "/portal-estudiante";
    case "instructor":
      return user.can_evaluate ? "/portal-evaluador" : "/portal-instructor";
    case "evaluador":
      return "/portal-evaluador";
    case "marketing":
      return "/marketing";
    case "super_admin":
    case "admin":
      return "/dashboard";
    default:
      return "/dashboard";
  }
}

export function getRoleFallbackRoute(user: Pick<AuthUser, "role" | "can_evaluate">): string {
  return getDefaultRouteForUser(user);
}
